export default {"src":"/_next/static/media/capy_aware.89ae36ee.svg","height":110,"width":130};